"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultHeaderFactory = exports.setDefaultHeaders = exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeaderConfig = /*#__PURE__*/function () {
  function HeaderConfig() {
    var _this = this;

    _classCallCheck(this, HeaderConfig);

    _defineProperty(this, "defaultHeaders", {});

    _defineProperty(this, "defaultHeaderFactory", void 0);

    _defineProperty(this, "setDefaultHeaders", function (headers) {
      _this.defaultHeaders = headers;
    });

    _defineProperty(this, "setDefaultHeadersFactory", function (headersFactory) {
      _this.defaultHeaderFactory = headersFactory;
    });
  }

  _createClass(HeaderConfig, [{
    key: "getDefaultHeaders",
    value: function getDefaultHeaders() {
      var factoryHeaders = this.defaultHeaderFactory ? this.defaultHeaderFactory() : {};
      return _objectSpread(_objectSpread({}, this.defaultHeaders), factoryHeaders);
    }
  }]);

  return HeaderConfig;
}();

var headerConfig = new HeaderConfig();
var _default = headerConfig; // Usage: call to set up a collection of default headers that will be added to all REST requests made by this client

exports["default"] = _default;

var setDefaultHeaders = function setDefaultHeaders(headers) {
  headerConfig.setDefaultHeaders(headers);
}; // Usage: call to set up a collection of default headers that will be added to all REST requests made by this client
// Pass in a factory that will be called for headers on each request - allowing for variable headers to be set up


exports.setDefaultHeaders = setDefaultHeaders;

var setDefaultHeaderFactory = function setDefaultHeaderFactory(headersFactory) {
  headerConfig.setDefaultHeadersFactory(headersFactory);
};

exports.setDefaultHeaderFactory = setDefaultHeaderFactory;